/**
 * Runtime value shape for every lookup field type: a single label string, or
 * an array of them for choose-many types (medication_lookup,
 * resident_allergy_lookup). This matches medication_lookup's existing,
 * already-shipped contract exactly — see the doc comment on
 * `LookupOption` in `@livingsyncs/types` for why label strings, not a
 * `{id,label}` object, are the stored value.
 */
export type LookupValue = string | string[] | null | undefined;

/** Human-readable display text for any lookup field value — used for locked/read-only rendering. */
export function lookupValueLabel(value: LookupValue): string {
  if (value === null || value === undefined || value === "") return "—";
  if (Array.isArray(value)) {
    return value.length > 0 ? value.join(", ") : "—";
  }
  return value;
}
